import { Mapper } from 'src/base/mapper'
import { CustomerTypeEntity } from 'src/data/entities/client.entity'
import { CustomerTypeModel } from 'src/domain/models/client.model'

export class CustomerTypeMapper extends Mapper<CustomerTypeEntity, CustomerTypeModel> {
	mapFrom(param: CustomerTypeEntity): CustomerTypeModel {
		return this.resultData(param)
	}

	mapTo(param: CustomerTypeModel): CustomerTypeEntity {
		return this.resultData(param)
	}

	resultData(param: CustomerTypeEntity | CustomerTypeModel) {
		return {
			id: param.id,
			name: param.name,
		}
	}
}
